import { Chip } from "@material-ui/core";
import React from "react";
import "./chipStyle.scss";

const DefaultChip = React.forwardRef((props, ref) => {

    const { label, className, size, style } = props

    return (
        <Chip
            className={`${style ? style : ""} ${className ? className : ""}`}
            size={size}
            label={label}
        />
    )
})

export default DefaultChip;